/* ahorro.in — Cold Alpine interactions, loaded on every page by sections/ahorro-header.liquid.
   1. Smart header: sticks to the top, tucks away on scroll down, returns on scroll up.
   2. Scroll reveal: rows, cards and headings fade up as they enter the screen.
   Everything is skipped for visitors who prefer reduced motion (the header still sticks). */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // 1. Smart header. The header section's own wrapper is only as tall as the
  // header, so `sticky` has to go on the outermost wrapper inside the page.
  const header = document.querySelector('.ah-header');
  if (header) {
    let host = header.closest('.shopify-section') || header;
    while (host.parentElement && host.parentElement.offsetHeight <= host.offsetHeight + 2 && host.parentElement !== document.body) {
      host = host.parentElement;
    }
    host.classList.add('ah-header-host');

    let lastY = window.scrollY;
    let ticking = false;
    const onScroll = () => {
      const y = window.scrollY;
      const drawerOpen = document.documentElement.classList.contains('ah-lock');
      const hide = !reduce && !drawerOpen && y > 120 && y > lastY + 4;
      const show = y < lastY - 4 || y <= 120;
      if (hide) host.classList.add('is-tucked');
      else if (show) host.classList.remove('is-tucked');
      lastY = y;
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
    }, { passive: true });
  }

  // 2. Scroll reveal. Only things below the fold at load get hidden first, so
  // nothing already on screen ever flickers.
  if (reduce || !('IntersectionObserver' in window)) return;
  const targets = document.querySelectorAll([
    '.ah-row', '.ah-card-p', '.ah-card', '.ah-terr__row', '.ah-drop', '.ah-trail',
    '.ah-index__group', '.ah-title', '.ah-ledger__head', '.ah-drops__head', '.ah-block', '.ah-notes'
  ].join(','));
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px' });

  const fold = window.innerHeight;
  targets.forEach((el) => {
    if (el.getBoundingClientRect().top < fold) return;
    // Stagger siblings in the same list a little (max ~240ms).
    const i = el.parentElement ? [...el.parentElement.children].indexOf(el) : 0;
    el.style.setProperty('--ah-delay', `${Math.min(i % 4, 3) * 80}ms`);
    el.classList.add('ah-reveal');
    io.observe(el);
  });
})();
